/**
 * SIM-SZENE LEIPZIG – Würfel-Logik für Szenarien
 * Optionen können ein Feld "dice" haben: { sides: 6, outcomes: [ { when: [1,2], effects: {...}, label?: "..." }, ... ] }
 * Rollt 1..sides und gibt die passenden Effekte sowie Roll/Outcome für UI zurück.
 */

/**
 * Würfelt und ermittelt den passenden Outcome.
 * @param {{ sides: number, outcomes: Array<{ when: number[], effects: object, label?: string }> }} dice
 * @returns {{ effects: object, roll: number, outcomeLabel?: string }}
 */
export function resolveDiceOutcome(dice) {
  if (!dice?.sides || !Array.isArray(dice.outcomes) || dice.outcomes.length === 0) {
    return { effects: {}, roll: 0, outcomeLabel: null };
  }
  const roll = 1 + Math.floor(Math.random() * dice.sides);
  const outcome = dice.outcomes.find((o) => Array.isArray(o.when) && o.when.includes(roll));
  const resolved = outcome ?? dice.outcomes[0];
  return {
    effects: resolved.effects ?? {},
    roll,
    outcomeLabel: resolved.label ?? null,
  };
}

/**
 * Prüft, ob eine Option Würfel-Logik nutzt.
 * @param {object} option - Szenario-Option
 * @returns {boolean}
 */
export function optionUsesDice(option) {
  return Boolean(option?.dice?.sides && Array.isArray(option.dice.outcomes) && option.dice.outcomes.length > 0);
}
